<script setup lang="ts">
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import type { IToC } from "~/models/IToC";
import type { ILegalText } from "~/models/ILegalText";
import type {
  ILinkChain,
  INote,
  IParagraphEntry,
  ISchema,
} from "~/models/IUserEntry";

type Props = {
  legalText: ILegalText;
  item: ILegalTextParagraph | IToC;
  toolIsSelected: boolean;
};
type Emits = {
  delete: [entry: IParagraphEntry];
  move: [entry: ILinkChain | INote | ISchema];
  editLink: [entry: ILinkChain];
  selection: [paragraph: ILegalTextParagraph, touch: boolean];
};

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const { t } = useI18n();
const { info } = useToast();

const handleHeadlineClick = () => {
  if (props.toolIsSelected) {
    info(t("unselectable"));
  }
};
</script>

<template>
  <ParagraphPart
    v-if="'paragraph' in item"
    :legalText="legalText"
    :legalTextParagraph="item"
    :isMainContent="false"
    :showLinks="false"
    @delete="emit('delete', $event)"
    @move="emit('move', $event)"
    @editLink="emit('editLink', $event)"
    @selection="emit('selection', item, $event)"
  />
  <p
    v-else
    class="text-center font-serif text-lg"
    @pointerup="handleHeadlineClick"
  >
    <span class="font-bold">
      {{ item.section }}
    </span>
    <br />
    {{ item.title }}
  </p>
</template>

<i18n>
{
  "de": {
    "unselectable": "Kapitelüberschriften können nicht markiert werden"
  },
  "en": {
    "unselectable": "Chapter headlines cannot be marked"
  }
}
</i18n>
